import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import the Redux store and Provider
import { Provider } from 'react-redux';
import store from './Redux/store'; // Ensure you have a store setup in this path
import { AuthProvider } from './Redux/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>

    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>

  </>
);

reportWebVitals();
